import fs from 'fs'
import chalk from 'chalk'
import semver from 'semver'
import git from './lib/git'
import config from './lib/config'
import cmd from './lib/cmd'
import util from './lib/util'
import log from './lib/log'

async function inputTag() {
  const options = [{
    type: 'input',
    name: 'tag',
    message: 'Input new version tag:',
  }]
  const answers = await cmd.prompt(options)
  return answers.tag
}

async function chooseTag(tag) {
  const levels = [
    `patch: ${semver.inc(tag, 'patch')}`,
    `minor: ${semver.inc(tag, 'minor')}`,
    `major: ${semver.inc(tag, 'major')}`,
    new cmd.Separator(),
    'input new version tag',
  ]
  const answers = await cmd.promptList('level', 'Choose new tag level', levels)
  const match = answers.level.match(/\d+\.\d+\.\d+/)
  if (match === null) {
    return await inputTag()
  }
  return match[0]
}

async function inquireTag() {
  const tags = git.getTagsSync()
  if (tags.length === 0) {
    return await inputTag()
  }
  const tag = git.getLastTagSync()
  if (semver.valid(tag) === null) {
    return await inputTag()
  }
  return await chooseTag(tag)
}

async function start() {
  const tag = await inquireTag()
  log.yellow(`release start ${tag}`)
  cmd.execSync(`git flow release start ${tag}`, { stdio: 'inherit' })
}

function getVersion() {
  const branch = git.getCurrentBranchSync()
  return util.extractReleaseVersion(branch)
}

async function finish() {
  const version = getVersion()
  if (version === null) {
    log.red('Current branch is not release branch.\nPlease checkout release branch')
  } else {
    log.info(`Version tag is: ${chalk.bold.green(version)}`)
    const pPath = util.cwdPath('package.json')
    if (fs.existsSync(pPath)) {
      const answers = await cmd.promptConfirm('Update version in package.json?')
      if (answers.confirm) {
        util.updateNpmVersion(pPath, version)
        try {
          await cmd.execSync(`git add package.json && git commit -m "${config.git.flow.release.finish_message}"`)
        } catch (error) {
          const stdout = error.stdout.toString()
          if (stdout.match(/nothing to commit/) === null) {
            log.info(stdout)
            throw error
          }
        }
      }
    }
    const cmdStr = `export GIT_MERGE_AUTOEDIT=no && git flow release finish -m ${config.git.tag.tag_message.replace(/ /g, '_')} ${version}`
    cmd.execSync(cmdStr, { stdio: 'inherit' })
    git.checkoutBranchSync('develop')
  }
}

async function release() {
  const version = getVersion()
  if (version !== null) {
    await finish()
  } else {
    const branches = git.getBranchesSync()
    const names = branches.filter(name => util.extractReleaseVersion(name) !== null)
    if (names.length === 0) {
      await start()
    } else {
      log.red(`Exist release branch: ${names.join(', ')}\nCheckout these release branch at first`)
    }
  }
}

export default {
  start: () => {
    start().catch(log.error)
  },
  finish: () => {
    finish().catch(log.error)
  },
  release: () => {
    release().catch(log.error)
  },
}
